module.exports = __webpack_public_path__ + "static/icon-7e649da2a6f7d57861861f29656c36b7.png";